import { cn } from "@shared/src/utils/cn";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-surfaces-bg-tertiary", className)} {...props} />;
}

export { Skeleton };
